<template>
  <v-card
    class="full-width full-height d-flex flex-column main-container default-background"
    flat
  >
    <v-sheet
      v-if="!isMobile"
      class="text-h5 text-center d-flex align-center justify-center pa-6 flex-grow-0 header-login-container"
      color="primary"
      dark
      style="color:#F4F6EB"
      v-html="appDescription"
    >
    </v-sheet>
    <base-form
      ref="form"
      class="flex-grow-1 d-flex align-center justify-space-evenly"
      :class="{ 'login-container': !isMobile }"
      @submit="submitForm"
    >
      <v-card
        class="text-center"
        :flat="isMobile"
        :elevation="isMobile ? 0 : 1"
        :width="!isMobile ? '30%' : null"
        max-width="416"
      >
        <div class="full-width full-height px-4 py-6">
          <div class="full-width d-flex justify-center align-center">
            <v-img
              aspect-ratio="1"
              max-width="100px"
              src="/static/img/logo.png"
              width="50%"
            ></v-img>
          </div>
          <v-card-title>
            <div class="text-center full-width text-h5 font-weight-bold">
              Đăng nhập
            </div>
          </v-card-title>
          <v-card-subtitle v-if="isMobile" class="pb-8 text-subtitle-2">
            {{ appName }}
          </v-card-subtitle>
          <v-card-text class="pb-0 pt-0">
            <v-text-field
              v-model="loginForm.username"
              autocomplete="username"
              dense
              :error-messages="errors.username || errors.email"
              height="50px"
              outlined
              placeholder="Tên đăng nhập"
              type="text"
              validate-on-blur
            >
              <template #prepend-inner>
                <v-icon class="pt-2" style="color:#9B9DA6;font-size:20px">
                  mdi-account-outline
                </v-icon>
              </template>
            </v-text-field>
            <v-text-field
              v-model="loginForm.password"
              autocomplete="current-password"
              dense
              :error-messages="errors.password"
              height="50px"
              outlined
              placeholder="Mật khẩu"
              :type="password.show ? 'text' : 'password'"
              validate-on-blur
            >
              <template #prepend-inner>
                <v-icon class="pt-2" style="color:#9B9DA6;font-size:20px">
                  mdi-lock-outline
                </v-icon>
              </template>
              <template #append>
                <v-icon
                  class="pt-2"
                  style="color:#9B9DA6;font-size:20px"
                  @click="password.show = !password.show"
                  >{{ password.show ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon
                >
              </template>
            </v-text-field>
          </v-card-text>
          <v-card-actions class="px-4 pt-0">
            <v-btn
              block
              class="text-none"
              color="primary"
              dark
              depressed
              elevation="1"
              large
              :loading="loginRequest.requesting"
              @click="submitForm"
            >
              Đăng nhập
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </base-form>
    <div>
      <div class="lg-version">
        <div class="text-caption">
          {{ copyright }}
        </div>
      </div>
    </div>
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex'
import { getTitle, getCopyright, getVersion, getDescription } from '../constant'

export default {
  components: {},
  data() {
    return {
      isSelectRole: false,
      loginForm: {
        username: '',
        password: '',
      },
      errors: {
        username: '',
        password: '',
      },
      loginRequest: {
        requesting: false,

        data: {},
      },
      password: {
        show: false,
      },
    }
  },

  computed: {
    appName() {
      return getTitle()
    },
    appDescription() {
      return getDescription()
    },
    version() {
      return getVersion()
    },
    copyright() {
      return getCopyright()
    },
    ...mapGetters({
      currentId: 'auth/currentId',
      currentUser: 'auth/currentUser',
    }),
  },

  created() {},

  methods: {
    async submitForm(e) {
      if (!(await this.$refs.form.validate())) return
      this.errors = {
        username: [],
        password: [],
      }
      this.requestLogin(this.loginForm)
    },

    async requestLogin(req) {
      if (this.loginRequest.requesting) return
      this.errors = {}
      try {
        this.loginForm.password = this.loginForm.password.trim()
        this.loginForm.username = this.loginForm.username.trim()
        this.loginRequest.requesting = true

        await this.$store.dispatch('auth/logIn', req)
        let nextRoute = this.$route.query['redirect'] || {
          name: 'home',
        }
        if (this.currentUser.roles.length > 1) {
          nextRoute = { name: 'login.select_role', query: this.$route.query }
        }
        this.$router.push(nextRoute)
      } catch (error) {
        console.error(error)
        this.loginRequest.requesting = false
        this.loginForm.password = ''
        if (error.response && error.response.status == 422) {
          this.errors = error.response.data.errors
        } else {
          this.$store.dispatch('notify/error', {
            message:
              error.response &&
              error.response.data &&
              error.response.data.message
                ? error.response.data.message
                : 'Đăng nhập thất bại',
            error,
          })
        }
      }
    },
  },
}
</script>
<style scoped>
.header-login-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}
.lg-version {
  position: fixed;
  bottom: 38px;
  font-weight: bold;
  left: 50%;
  transform: translateX(-50%) !important;
}
.login-container {
  background-image: url(/static/img/login-background-2.png);
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: bottom;
}
.card-shadown {
  box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.03) !important;
}
.justify-space-evenly {
  -webkit-box-pack: space-evenly;
  -ms-flex-pack: space-evenly;
  justify-content: space-evenly;
}
</style>
